import type { User } from '../context/AuthContext';

/**
 * Platform Admin is a server-authenticated role. Browser storage is never an
 * authorization signal, so a scoped Program Operator cannot inherit Owner UI.
 */
export function isPlatformAdminUser(user: User | null | undefined): boolean {
  return Boolean(
    user?.isAdmin === true ||
    user?.roles?.some((role) => role.toLowerCase() === 'admin')
  );
}
